import { Box, Chip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ConfirmPopover } from "../../component";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { placeholderImage } from "../../assets/img";
export const columns = (handleView, handleDelete) => [
  {
    accessorKey: "sortOrder",
    header: "S. No.",
    style: {
      width: 70,
    },
  },
  {
    accessorKey: "pr_thumbnail",
    header: "Thumbnail",
    style: {
      width: 250,
    },
    cell: (ele) => {
      const src = ele || placeholderImage;
      return (
        <img
          src={src}
          alt="thumbnail"
          style={{ width: "180px", height: "120px", objectFit: "cover" }}
        />
      );
      // return <img src={ele} alt="thumbnail" />;
    },
  },
  {
    accessorKey: "pr_heading",
    header: "Title",
  },

  {
    accessorKey: "isActive",
    header: "Status",
    cell: (ele) => {
      return ele === true ? (
        <Chip label="Enabled" variant="outlined" color="success" size="small" />
      ) : (
        <Chip label="Disabled" variant="outlined" color="error" size="small" />
      );
    },
  },
  {
    accessorKey: "action",
    header: "Action",
    style: {
      width: 150,
    },
    cell: (ele, row) => {
      return (
        <Box>
          <IconButton
            sx={{ mr: 0.5 }}
            aria-label="edit"
            color="secondary"
            onClick={() => handleView(row, "/app/add-pr-article")}
          >
            <EditIcon />
          </IconButton>
          <ConfirmPopover
            title="Sure to delete?"
            onConfirm={() => handleDelete(row._id)}
          >
            <IconButton aria-label="delete" color="error">
              <DeleteOutlineIcon />
            </IconButton>
          </ConfirmPopover>
        </Box>
      );
    },
  },
];
